import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { TrustBar } from "@/components/site/TrustBar";
import { WhoWeAre } from "@/components/site/WhoWeAre";
import { Services } from "@/components/site/Services";
import { TruckShowcase } from "@/components/site/TruckShowcase";
import { HowWeWork } from "@/components/site/HowWeWork";
import { WhyPrimeLane } from "@/components/site/WhyPrimeLane";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";

export default function Landing() {
  return (
    <div className="bg-white">
      <Header />
      <main>
        <Hero />
        <TrustBar />
        <WhoWeAre />
        <Services />
        <TruckShowcase />
        <HowWeWork />
        <WhyPrimeLane />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
